// Checkout island: once the shopper has entered their city and province (or changes the
// delivery option or payment method), fetch the delivery options, payment methods and totals for
// that address and swap those parts of the form. Without JavaScript, Enter / "Apply" re-checks
// the page.

const API = "/api/method/softech_commerce.api.checkout.get_shipping_options";
const FIELDS = ["city", "province", "shipping_rate", "payment_method"];
const PARTS = {
	delivery_html: "[data-checkout-delivery]",
	payment_html: "[data-checkout-payment]",
	totals_html: "[data-checkout-totals]",
};
const DELAY = 300;

function swap(form, selector, html) {
	const old = form.querySelector(selector);
	if (!old || !html) return;
	const template = document.createElement("template");
	template.innerHTML = html; // our own server-rendered part (autoescaped store templates)
	const fresh = template.content.firstElementChild;
	if (fresh) old.replaceWith(fresh);
}

export function initCheckout(form) {
	if (!form.querySelector("[data-checkout-totals]")) return;
	let timer = 0;
	let request = 0;

	async function load(current) {
		const data = new FormData(form);
		const params = new URLSearchParams({ lang: form.dataset.lang || "" });
		FIELDS.forEach((name) => params.set(name, data.get(name) || ""));
		try {
			const response = await fetch(`${API}?${params}`, {
				headers: { Accept: "application/json" },
			});
			if (!response.ok || current !== request) return;
			const { message } = await response.json();
			// a newer change was made meanwhile: its own request will update the page
			if (!message || message.total === null || current !== request) return;
			const focused = document.activeElement;
			const focus =
				focused && form.contains(focused) && focused.name
					? [focused.name, focused.value]
					: null;
			Object.entries(PARTS).forEach(([key, selector]) => swap(form, selector, message[key]));
			const expected = form.querySelector("[name=expected_total]");
			if (expected) expected.value = message.total;
			if (focus && !form.contains(focused)) {
				// keyboard users keep their place in the swapped radio group
				const again = [...form.querySelectorAll(`[name="${focus[0]}"]`)].find(
					(el) => el.value === focus[1]
				);
				if (again) again.focus();
			}
		} catch (e) {
			// keep the page as it is: placing the order re-checks everything on the server
		}
	}

	form.addEventListener("change", (event) => {
		if (!FIELDS.includes(event.target.name)) return;
		const current = ++request; // answers to earlier changes are ignored from now on
		clearTimeout(timer);
		timer = setTimeout(() => load(current), DELAY);
	});
}
